import { wsService } from "./wsService";

const section = "tasks";

const TASK_TRANSFERENCIA = 1;
const TASK_PREPARACION = 2;
const TASK_GUARDADO = 3;
const TASK_EMPAQUETADO = 4;
const TASK_EXPEDICION = 5;
const TASK_CONTROL = 6;
const TASK_REPOSICION = 7;

const MOVEMENT_TYPE_LPN = "lpn";
const MOVEMENT_TYPE_PRODUCT = "product";

const STATE_PENDIENTE = "PEN";
const STATE_ASIGNADA = "ASI";
const STATE_EN_PROCESO = "PRO";
const STATE_FINALIZADO = "FIN";
const STATE_CANCELADA = "CAN";

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function cancel(param = {}) {
  return wsService.make_post_request(section + "/cancel", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function list_types(param = {}) {
  return wsService.make_post_request(section + "/list-types", param);
}

function list_states(param = {}) {
  return wsService.make_post_request(section + "/list-states", param);
}

function perform_task(param = {}) {
  return wsService.make_post_request(section + "/perform-task", param);
}

function getStateColor(state_id) {
  switch (state_id) {
    case STATE_PENDIENTE:
      return "grey";
    case STATE_ASIGNADA:
      return "info";
    case STATE_EN_PROCESO:
      return "warning";
    case STATE_FINALIZADO:
      return "success";
    case STATE_CANCELADA:
      return "error";
    default:
      return "primary";
  }
}

function getPrioridadColor(prioridad) {
  switch (prioridad) {
    case "Alta":
      return "error";
    case "Media":
      return "warning";
    case "Baja":
      return "grey";
    default:
      return "primary";
  }
}

export const taskService = {
  section,

  TASK_TRANSFERENCIA,
  TASK_PREPARACION,
  TASK_GUARDADO,
  TASK_EMPAQUETADO,
  TASK_EXPEDICION,
  TASK_CONTROL,
  TASK_REPOSICION,

  MOVEMENT_TYPE_LPN,
  MOVEMENT_TYPE_PRODUCT,

  STATE_PENDIENTE,
  STATE_ASIGNADA,
  STATE_EN_PROCESO,
  STATE_FINALIZADO,
  STATE_CANCELADA,

  filter,
  remove,
  create,
  update,
  cancel,
  list_types,
  list_states,
  perform_task,

  getStateColor,
  getPrioridadColor,
};
